import React from 'react';

const Player = ({ player, playerImagesRef, playerImageSize }) => {
  let playerImage = playerImagesRef.current.standing;

  if (player.isDashing) {
    playerImage = playerImagesRef.current.dash;
  } else if (player.isJumping) {
    playerImage = playerImagesRef.current.jumping;
  } else if (player.isRunning) {
    if (Math.floor(player.score / 10) % 2 === 0) {
      playerImage = playerImagesRef.current.runningStep1;
    } else {
      playerImage = playerImagesRef.current.runningStep2;
    }
  }

  return playerImage ? (
    <img
      src={playerImage.src}
      alt="player"
      style={{
        position: 'absolute',
        left: player.direction === 'left' ? `${player.x + playerImageSize}px` : `${player.x}px`,
        top: `${player.y}px`,
        width: `${playerImageSize}px`,
        height: `${playerImageSize}px`,
        transform: player.direction === 'left' ? 'scaleX(-1)' : 'scaleX(1)',
      }}
    />
  ) : null;
};

export default Player;